export default [
    {
        path: "/mime",
        name: "mime",
        component: () => import("./index"),
        meta: {
            title: "个人中心"
        }
    },
    {
        path: "/mime/password",
        name: "UpdatePassword",
        component: () => import("./UpdatePassword"),
        meta: {
            title: "修改密码"
        }
    },
    {
        path: "/mime/update",
        name: "Update",
        component: () => import("./Update"),
        meta: {
            title: "个人信息"
        }
    },
]